var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"width":"1","height":"20","viewBox":"0 0 1 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('line',{attrs:{"x1":"0.5","y1":"20","x2":"0.5","stroke":"#DFE1E6"}})])}
var staticRenderFns = []

export { render, staticRenderFns }